(() => {
  const initTabs = (root = document) => {
    root.querySelectorAll('[data-codskins-tabs]').forEach((tabs) => {
      if (tabs.dataset.codskinsTabsReady === 'true') return;
      tabs.dataset.codskinsTabsReady = 'true';

      const buttons = [...tabs.querySelectorAll('[data-tab-target]')];
      const panels = [...tabs.querySelectorAll('[data-tab-panel]')];
      const select = tabs.querySelector('[data-tab-select]');

      const activate = (name, moveFocus = false) => {
        buttons.forEach((button) => {
          const active = button.dataset.tabTarget === name;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
          if (active && moveFocus) button.focus({ preventScroll: true });
        });

        panels.forEach((panel) => {
          const active = panel.dataset.tabPanel === name;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        if (select && select.value !== name) select.value = name;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => activate(button.dataset.tabTarget));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const currentIndex = buttons.indexOf(button);
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = buttons[(currentIndex + step + buttons.length) % buttons.length];
          activate(next.dataset.tabTarget, true);
        });
      });

      select?.addEventListener('change', () => activate(select.value));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTabs());
  } else {
    initTabs();
  }

  document.addEventListener('shopify:section:load', (event) => initTabs(event.target));
})();
